<template>
    <div id="sponsors" class="sponsors container">
            <template v-for="(item, index) in partners" :key="index">
                <h2>{{item.title}}</h2>
                <div :class="item.classList">
                    <div class="__row">
                        <div class="__col">
                            <div v-for="(item,index) in item.items" :key="index" 
                                class="__logo" 
                                :class="item.classList"
                                >
                                <a :href="item.href" target="_blank">
                                    <img  :src="item.logo" :alt="item.alt">
                                </a>    
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        <div class="__btn-wrap">
            <button
                @click="popup = true"
                >
                <img class="__icon" :src="icon">
                Хочу стать партнёром
            </button>
        </div>
        <Transition>
            <PopupBlock v-if="popup" @event-close-popup="handleEventClosePopup">
                <slot></slot>
                <!-- <SponsorForm :sendResult="sendResult" @return-data="handleEventReturnData"></SponsorForm> -->
            </PopupBlock>
        </Transition>
    </div>
</template>
<script>
import icon from '@/assets/handshake.svg'
import logoCandela from '@/assets/partners/platinum/candela-logo.png'
import logoDeka from '@/assets/partners/gold/deka-logo.svg'
import logoRustorg from '@/assets/partners/gold/rustorg-logo.svg'
import logoOblik from '@/assets/partners/oblik-logo.svg'
import logoBbb from '@/assets/partners/bbb-logo.svg'
// import logoNovakute from '@/assets/partners/novakute-logo.svg'
import logoMartinex from '@/assets/partners/martinex-logo.png'
import logoArgumentum from '@/assets/partners/argumentum-logo.svg'
import logoEldermafill from '@/assets/partners/gold/eldermafill-logo.svg'
import logoCapello from '@/assets/partners/capello-logo.svg'
import logoNaturesBounty from '@/assets/partners/nb-logo.svg'
import logoChardon from '@/assets/partners/chardon-logo.svg'
import logoMintaka from '@/assets/partners/mintaka-logo.svg'
import logoEdmed from '@/assets/partners/edmed-logo.svg'
import logoVallex from '@/assets/partners/vallex-logo.svg'
import logoTrinet from '@/assets/partners/trinet-logo.svg'
import logoGleb from '@/assets/partners/glebseo-logo.svg'
import logoBart from '@/assets/partners/bart-logo.svg'
import logoShakin from '@/assets/partners/shakin-logo.svg'

import PopupBlock from './PopupBlock';

import { getParam } from '@/lib/getParam';

export default {
    name: 'PartnersBlock',
    components: { 
        PopupBlock,
        // SponsorForm,
    },
    props: {},
    // emits: [ 'returnData' ],
    data() {
        return {
            icon,
            popup: false,
            // devel: false,

            logoCandela,
            logoDeka,
            logoEldermafill,
            logoOblik,
            logoMartinex,
            logoArgumentum,
            logoCapello,
            logoNaturesBounty,
            logoChardon,
            logoMintaka,
            logoEdmed,
            logoTrinet,
            logoGleb,
            logoBart,
            logoShakin,
            logoRustorg,

            partners: [
                { 
                    title: 'Платиновый партнёр',
                    classList: '__platinum',
                    items: [
                        {
                            logo: logoCandela,
                            href: 'https://candela-laser.ru/?utm_source=medpervichka',
                            alt: 'Candela laser logo',
                        },
                    ],
                },
                {
                    title: 'Золотые партнёры',
                    classList: '__gold',
                    items: [
                        {
                            logo: logoDeka,
                            href: 'https://dekalaser.ru/?utm_source=medpervichka',
                            alt: 'Deka laser logo',

                        },
                        {
                            logo: logoEldermafill,
                            href: 'https://eldermafill.ru/?utm_source=medpervichka',
                            alt: 'Eldermafill logo',
                        },
                        {
                            logo: logoRustorg,
                            href: 'https://medkladovka.ru/?utm_source=medpervichka',
                            alt: 'РУСТОРГ logo',
                        },
                    ],
                },
                {
                    title: 'Партнёры',
                    classList: '__comm',
                    items: [
                        {
                            logo: logoOblik,
                            href: 'https://oblikmagazine.ru/?utm_source=medpervichka',
                            alt: 'Oblik logo',
                        },
                        {
                            logo: logoBbb,
                            href: 'https://margocherniak.ru/bbb2025?utm_source=medpervichka',
                            alt: 'Big Beauty Boss logo',
                        },
                        {
                            logo: logoMartinex,
                            href: 'https://www.martinex.ru/?utm_source=medpervichka',
                            alt: 'Martinex logo',
                        },
                        {
                            logo: logoArgumentum,
                            href: 'https://anesta.farm/?utm_source=yandex&utm_medium=cpc&utm_campaign=113631440&utm_content=16421115598&utm_term=%D0%B0%D0%BD%D0%B5%D1%81%D1%82%D0%B0',
                            alt: 'Argumentum logo',
                            classList: 'argumentum',
                        },
                        {
                            logo: logoCapello,
                            href: 'https://capellolaser.ru/?utm_source=medpervichka',
                            alt: 'Capello laser logo',
                        },
                        {
                            logo: logoNaturesBounty,
                            href: 'https://www.naturesbounty.ru/?utm_source=medpervichka',
                            alt: 'Natures Bounty logo',
                        },
                        {
                            logo: logoVallex,
                            href: 'https://vallexpro.ru/?utm_source=medpervichka',
                            alt: 'Vallex logo',
                        },
                        {
                            logo: logoMintaka,
                            href: 'https://mintakagroup.ru/?utm_source=medpervichka',
                            alt: 'Mintaka logo',
                            classList: 'mintaka',
                        },
                        {
                            logo: logoChardon,
                            href: 'https://taplink.cc/chardon?ysclid=m7u7lvyo72861393845&utm_source=medpervichka',
                            alt: 'Chardon logo',
                        },
                        {
                            logo: logoEdmed,
                            href: 'https://edmed.ru/multidisciplinary-cosmetology-2025?utm_source=medpervichka',
                            alt: 'Галактический интенсив logo',
                            classList: 'edmed',
                        },
                        {
                            logo: logoTrinet,
                            href: 'https://trinet.ru/services/seo-prodvizhenie-saytov/medicinskih-klinik/?utm_source=medpervichka',
                            alt: 'TRINET Group logo',
                            classList: 'trinet',
                        },
                        {
                            logo: logoGleb,
                            href: 'https://t.me/GlebSEO?utm_source=medpervichka',
                            alt: 'Gleb SEO logo',
                            classList: 'glebseo',
                        },
                        {
                            logo: logoBart,
                            href: 'https://bartstudio.ru/?utm_source=medpervichka',
                            alt: 'Bart studio logo',
                            classList: 'bart',
                        },
                        {
                            logo: logoShakin,
                            href: 'https://shakin.ru/?utm_source=medpervichka',
                            alt: 'Shakin logo',
                            classList: 'shakin',
                        },
                    ],
                },
            ]

        }
    },
    mounted() {
        this.devel = getParam('devel') ? true : false
    },
    methods: {
        handleEventClosePopup: function() {
            this.popup = false
        },
        // handleEventReturnData: function(returnData) {
        //     this.$emit('returnData', returnData )
        // },
    }
}
</script>
<style lang="scss">
$primary: #1E9BD8;
$text-color: #FCF9F9;
.sponsors{
    // height: 150px;
    h2{
        padding-left: 10px;
    }
    margin-bottom: 1.5em;
    .__platina, .__platinum, .__gold, .__comm{
        margin-bottom: 35px;
        justify-content: center;
        .__col{
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
        }
    }
    .__logo{
        width: fit-content;
        padding: 25px 15px;
        margin: 2px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        img{
            height: 60px;
            max-width: 100%;
        }
        &.mintaka{
            img{
                margin-top: -50px;
                height: 110px;
            }
        }
        &.argumentum{
            img{
                margin-top: -15px;
                margin-bottom: -15px;
                height: 90px;
            }
        }
        &.edmed{
            img{
                margin-top: -50px;
                margin-bottom: -50px;
                height: 160px;
            }
        }
        &.trinet{
            img{
                margin-top: -25px;
                margin-bottom: -25px;
                height: 80px;
            }
        }
        &.glebseo{
            img{
                // margin-top: -25px;
                // margin-bottom: -25px;
                height: 60px;
            }
        }
        // &.candela, &.eldermafill{
        //     img{
        //         height: 60px;
        //         max-width: 100%;
        //     }
        //     // background-color: #101820;
        // }
        // &.deka{
        //     // background-color: #fff;
        //     img{
        //         height: 60px;
        //         max-width: 100%;
        //     }
        // }
        // &.oblik, &.novakute, &.martinex, &.capello, &.nb{
        //     img{
        //         height: 60px;
        //         // height: auto;
        //         max-width: 100%;
        //     };
        // }
    }
    .__icon{
        height: 46px;
        width: 46px;
        margin-right: 10px;
    }
    .__btn-wrap{
        // background-image: radial-gradient(circle at -20% -127%, #1E9BD8 0%, transparent 48%), radial-gradient(circle at 108% 0%, #1d0d8e -42%, transparent 74%);
        // border-top: solid 1px #fff;
        padding: 2em;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        // border-radius: 15px;
        button{
            padding: 10px 24px 10px 15px;
            text-transform: uppercase;
            background: $primary;
            border: none;
            border-radius: 5px;
            color: $text-color;
            font-size: 1.25em;
            display: flex;
            align-items: center;
            transition: .3s;
            position: relative;
            z-index: 10;
            &:hover{
                transition: .3s;
                background: darken( $primary, 5% );
                color: #fff;
            }
        }
    }
}
// .card{
//     .row{
//         justify-content: space-around;
//         div.col{
//             font-size: 2em;
//             background-color: #206daf;
//             margin: .5em;
//             padding: .5em;
//             color: #fff;
//             border-radius: 15px;
//         }
//     }
// }
</style>